import React from "react";
import { ShoppingBag } from "lucide-react";
import logo from "../images/logo.png"; 

export default function Header() {
return (
    <header className="bg-primary text-white shadow">
        <div className="container flex justify-between items-center py-4">
            <div className="flex items-center gap-2">
                <img src={logo} alt="AcheiPreço logo" className="h-48 w-auto"/>
                {/* <ShoppingBag size={28} />
                <h1 className="text-xl font-bold">AcheiPreço</h1> */}
            </div>
            {/* <nav className="hidden sm:flex gap-6">
                <a href="#" className="hover:text-secondary">Ofertas</a>
                <a href="#" className="hover:text-secondary">Categorias</a>
                <a href="#" className="hover:text-secondary">Contato</a>
            </nav> */}
        </div>
    </header>
);
}
